@if (formGroup) {
  <form [formGroup]="formGroup">
    <div class="grid gap-12">
      @for (
        statement of conditionalStatementsFormArray.controls;
        track statement;
        let index = $index
      ) {
        <em-box class="flex items-center gap-3 mb-2 shadow-md">
          <em-conditional-statement
            class="w-full"
            [formGroup]="statement"
            [availableOperators]="availableOperators$ | async"
            [canDelete]="allowEmpty() || canDeleteConditions"
          >
            <ng-template let-conditionControl>
              <ng-container
                *ngTemplateOutlet="
                  template;
                  context: {$implicit: conditionControl}
                "
              ></ng-container>
            </ng-template>
          </em-conditional-statement>
          @if (index > 0 && logicalOperatorControl.value) {
            <div
              class="operand-box floating-operand"
              [ngClass]="
                'operand-box--' + logicalOperatorControl.value.toLowerCase()
              "
            >
              {{ logicalOperatorControl.value }}
            </div>
          }
        </em-box>
      }
    </div>
    @if (outerAvailableOperators$ | async; as outerAvailableOperators) {
      @if (outerAvailableOperators.length) {
        <div class="flex justify-center mt-4 mb-4 gap-3">
          @for (operator of outerAvailableOperators; track operator) {
            <em-button type="secondary" (click)="addNewStatement(operator)">
              + {{ operator.toUpperCase() }}
            </em-button>
          }
        </div>
      }
    }
  </form>
}
